import "bootstrap/dist/css/bootstrap.min.css";
import Header from "./header";
import Footer from "./footer";
import { Card, CardBody, CardTitle, CardSubtitle, Table } from "reactstrap";
import { useEffect, useState } from "react";
import axios from "axios";

function Courses() {

    const [courseRes, setCoureseRes] = useState();

    useEffect(() => {
        axios
            .get(
                "https://lgl8fzfq6i.execute-api.ap-south-1.amazonaws.com/dev/courses"
            )
            .then((response) => {
                console.log("Course data==>:", response);
                let responseData = response?.data?.courses;
                responseData.sort((a, b) => a.courseNumber - b.courseNumber);
                setCoureseRes([...responseData]);
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }, []);

    return (
        <div className="App" style={{ paddingHorizontal: 25 }}>
            <div>
                <Header />
                <Card>
                    <CardBody>
                        <CardTitle tag="h5">Courses Listing</CardTitle>
                        <CardSubtitle className="mb-2 text-muted" tag="h6">
                            Overview of the courses
                        </CardSubtitle>

                        <Table className="no-wrap mt-3 align-middle" responsive borderless>
                            <thead>
                                <tr style={{ whiteSpace: "nowrap" }}>
                                    <th>Course Number</th>
                                    <th>Course Name</th>
                                    <th>Credit Hours</th>
                                    <th>Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                {courseRes?.map((tdata, index) => (
                                    <tr key={index} className="border-top">
                                        <td>{tdata.courseNumber}</td>
                                        <td>{tdata.courseName}</td>
                                        <td>{tdata.creditHours}</td>
                                        <td>{tdata.description}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </CardBody>
                </Card>
                <Footer />
            </div>
        </div>
    );
}

export default Courses;
